import { CONNECTIONS_SUCCESS, LOGGED_OUT, SET_CONNECTIONS_STATUS, SYNC_ALL_SUCCESS, } from 'actions/types';
import { generateEmptyBalances } from 'utils/api/generateEmptyBalances';
import { EDIT_SPACE_INFO, SWITCHED_SPACE } from 'features/spaces/constants';
const initialState = {
    pots: [],
    debt: [],
    assets: [],
    savings: [],
    networth: [],
    portfolio: [],
    investment: [],
    everydayAll: [],
    savingsAll: [],
    potsLastFetchedTimeStamp: undefined,
    debtLastFetchedTimeStamp: undefined,
    assetsLastFetchedTimeStamp: undefined,
    savingsLastFetchedTimeStamp: undefined,
    networthLastFetchedTimeStamp: undefined,
    checkingLastFetchedTimeStamp: undefined,
    portfolioLastFetchedTimeStamp: undefined,
    investmentLastFetchedTimeStamp: undefined,
    potsBalanceHistoryReq: false,
    debtBalanceHistoryReq: false,
    assetsBalanceHistoryReq: false,
    savingsBalanceHistoryReq: false,
    networthBalanceHistoryReq: false,
    checkingBalanceHistoryReq: false,
    portfolioBalanceHistoryReq: false,
    investmentBalanceHistoryReq: false,
    everydayAllBalanceHistoryReq: false,
    savingsAllBalanceHistoryReq: false,
    investmentAllBalanceHistoryReq: false,
    networthAllBalanceHistoryReq: false,
    lastSyncChange: undefined,
    syncInvalidationCount: 0,
};
// Pots come from Emma's own services, so a bank sync can't
// change them and they keep their timestamps
const invalidateBankBalanceHistory = (state) => ({
    ...state,
    debtLastFetchedTimeStamp: undefined,
    assetsLastFetchedTimeStamp: undefined,
    savingsLastFetchedTimeStamp: undefined,
    networthLastFetchedTimeStamp: undefined,
    checkingLastFetchedTimeStamp: undefined,
    portfolioLastFetchedTimeStamp: undefined,
    investmentLastFetchedTimeStamp: undefined,
    everydayAllLastFetchedTimeStamp: undefined,
    savingsAllLastFetchedTimeStamp: undefined,
    investmentAllLastFetchedTimeStamp: undefined,
    networthAllLastFetchedTimeStamp: undefined,
    debtAllLastFetchedTimeStamp: undefined,
    assetAllLastFetchedTimeStamp: undefined,
    syncInvalidationCount: state.syncInvalidationCount + 1,
});
const balanceHistoryreducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGGED_OUT:
        case EDIT_SPACE_INFO:
        case SWITCHED_SPACE: {
            return initialState;
        }
        case 'GET_ALL_BALANCE_HISTORY_REQUEST': {
            switch (action.extra.graphSection) {
                case 'EVERYDAY': {
                    return { ...state, everydayAllBalanceHistoryReq: true };
                }
                case 'SAVINGS': {
                    return { ...state, savingsAllBalanceHistoryReq: true };
                }
                case 'INVESTMENT': {
                    return { ...state, investmentAllBalanceHistoryReq: true };
                }
                case 'NET_WORTH': {
                    switch (action.extra.graphType) {
                        case 'ASSET':
                            return {
                                ...state,
                                assetAllBalanceHistoryReq: true,
                            };
                        case 'DEBT':
                            return {
                                ...state,
                                debtAllBalanceHistoryReq: true,
                            };
                        default:
                            return { ...state, networthAllBalanceHistoryReq: true };
                    }
                }
                default:
                    return state;
            }
        }
        case 'GET_ALL_BALANCE_HISTORY_FAILURE': {
            switch (action.extra.graphSection) {
                case 'EVERYDAY': {
                    return { ...state, everydayAllBalanceHistoryReq: false };
                }
                case 'SAVINGS': {
                    return { ...state, savingsAllBalanceHistoryReq: false };
                }
                case 'INVESTMENT': {
                    return { ...state, investmentAllBalanceHistoryReq: false };
                }
                case 'NET_WORTH': {
                    switch (action.extra.graphType) {
                        case 'ASSET':
                            return {
                                ...state,
                                assetAllBalanceHistoryReq: false,
                            };
                        case 'DEBT':
                            return {
                                ...state,
                                debtAllBalanceHistoryReq: false,
                            };
                        default:
                            return { ...state, networthAllBalanceHistoryReq: false };
                    }
                }
                default:
                    return state;
            }
        }
        case 'GET_ALL_BALANCE_HISTORY_SUCCESS': {
            switch (action.extra.graphSection) {
                case 'EVERYDAY': {
                    return {
                        ...state,
                        everydayAllBalanceHistoryReq: false,
                        everydayAll: [...action.payload.history].reverse(),
                        everydayAllLastFetchedTimeStamp: new Date().getTime(),
                    };
                }
                case 'SAVINGS': {
                    return {
                        ...state,
                        savingsAllBalanceHistoryReq: false,
                        savingsAll: [...action.payload.history].reverse(),
                        savingsAllLastFetchedTimeStamp: new Date().getTime(),
                    };
                }
                case 'INVESTMENT': {
                    return {
                        ...state,
                        investmentAllBalanceHistoryReq: false,
                        investmentAll: [...action.payload.history].reverse(),
                        investmentAllLastFetchedTimeStamp: new Date().getTime(),
                    };
                }
                case 'NET_WORTH': {
                    switch (action.extra.graphType) {
                        case 'ASSET':
                            return {
                                ...state,
                                assetAllBalanceHistoryReq: false,
                                assetAll: [...action.payload.history].reverse(),
                                assetAllLastFetchedTimeStamp: new Date().getTime(),
                            };
                        case 'DEBT':
                            return {
                                ...state,
                                debtAllBalanceHistoryReq: false,
                                debtAll: [...action.payload.history].reverse(),
                                debtAllLastFetchedTimeStamp: new Date().getTime(),
                            };
                        default:
                            return {
                                ...state,
                                networthAllBalanceHistoryReq: false,
                                networthAll: [...action.payload.history].reverse(),
                                networthAllLastFetchedTimeStamp: new Date().getTime(),
                            };
                    }
                }
                default:
                    return state;
            }
        }
        case 'GET_POT_BALANCE_HISTORY_REQUEST': {
            return {
                ...state,
                potsBalanceHistoryReq: true,
            };
        }
        case 'GET_POT_BALANCE_HISTORY_SUCCESS': {
            const { balances } = action.payload;
            const finalBalances = balances.length > 0
                ? balances
                : generateEmptyBalances(action.extra.from, action.extra.to);
            return {
                ...state,
                pots: finalBalances,
                potsBalanceHistoryReq: false,
                potsLastFetchedTimeStamp: new Date().getTime(),
            };
        }
        case 'GET_POT_BALANCE_HISTORY_FAILURE': {
            return {
                ...state,
                potsBalanceHistoryReq: false,
            };
        }
        case 'GET_PORTFOLIO_BALANCE_HISTORY_REQUEST': {
            return {
                ...state,
                portfolioBalanceHistoryReq: true,
            };
        }
        case 'GET_PORTFOLIO_BALANCE_HISTORY_SUCCESS': {
            const { balances } = action.payload;
            const finalBalances = balances.length > 0
                ? balances
                : generateEmptyBalances(action.extra.from, action.extra.to);
            return {
                ...state,
                portfolio: finalBalances,
                portfolioBalanceHistoryReq: false,
                portfolioLastFetchedTimeStamp: new Date().getTime(),
            };
        }
        case 'GET_PORTFOLIO_BALANCE_HISTORY_FAILURE': {
            return {
                ...state,
                portfolioBalanceHistoryReq: false,
            };
        }
        case 'GET_BALANCE_REQUEST': {
            switch (action.extra.accountType) {
                case 'SAVINGS':
                    return {
                        ...state,
                        savingsBalanceHistoryReq: true,
                    };
                case 'NETWORTH':
                    return {
                        ...state,
                        networthBalanceHistoryReq: true,
                    };
                case 'INVESTMENT':
                    return {
                        ...state,
                        investmentBalanceHistoryReq: true,
                    };
                case 'CHECKING':
                    return {
                        ...state,
                        checkingBalanceHistoryReq: true,
                    };
                case 'DEBT':
                    return {
                        ...state,
                        debtBalanceHistoryReq: true,
                    };
                case 'ASSETS':
                    return {
                        ...state,
                        assetsBalanceHistoryReq: true,
                    };
                default:
                    return state;
            }
        }
        case 'GET_BALANCE_SUCCESS': {
            switch (action.extra.accountType) {
                case 'SAVINGS':
                    return {
                        ...state,
                        savings: action.payload.history,
                        savingsBalanceHistoryReq: false,
                        savingsLastFetchedTimeStamp: new Date().getTime(),
                    };
                case 'NETWORTH':
                    return {
                        ...state,
                        networth: action.payload.history,
                        networthBalanceHistoryReq: false,
                        networthLastFetchedTimeStamp: new Date().getTime(),
                    };
                case 'INVESTMENT':
                    return {
                        ...state,
                        investment: action.payload.history,
                        investmentBalanceHistoryReq: false,
                        investmentLastFetchedTimeStamp: new Date().getTime(),
                    };
                case 'CHECKING':
                    return {
                        ...state,
                        checking: action.payload.history,
                        checkingBalanceHistoryReq: false,
                        checkingLastFetchedTimeStamp: new Date().getTime(),
                    };
                case 'DEBT':
                    return {
                        ...state,
                        debt: action.payload.history,
                        debtBalanceHistoryReq: false,
                        debtLastFetchedTimeStamp: new Date().getTime(),
                    };
                case 'ASSETS':
                    return {
                        ...state,
                        assets: action.payload.history,
                        assetsBalanceHistoryReq: false,
                        assetsLastFetchedTimeStamp: new Date().getTime(),
                    };
                default:
                    return state;
            }
        }
        case 'GET_BALANCE_FAILURE': {
            /**
             * Adding ?. just for extra security
             */
            switch (action.extra?.accountType) {
                case 'SAVINGS':
                    return {
                        ...state,
                        savingsBalanceHistoryReq: false,
                    };
                case 'NETWORTH':
                    return {
                        ...state,
                        networthBalanceHistoryReq: false,
                    };
                case 'INVESTMENT':
                    return {
                        ...state,
                        investmentBalanceHistoryReq: false,
                    };
                case 'CHECKING':
                    return {
                        ...state,
                        checkingBalanceHistoryReq: false,
                    };
                case 'DEBT':
                    return {
                        ...state,
                        debtBalanceHistoryReq: false,
                    };
                case 'ASSETS':
                    return {
                        ...state,
                        assetsBalanceHistoryReq: false,
                    };
                default:
                    return state;
            }
        }
        case SET_CONNECTIONS_STATUS: {
            if (action.payload) {
                return state;
            }
            return invalidateBankBalanceHistory(state);
        }
        // lastChange is the latest successful sync across the connections, and the
        // backend only moves it once the synced balances are saved
        case CONNECTIONS_SUCCESS:
        case SYNC_ALL_SUCCESS: {
            const { lastChange } = action.payload;
            if (lastChange === undefined || lastChange === state.lastSyncChange) {
                return state;
            }
            if (state.lastSyncChange === undefined) {
                // First response since launch or a space switch, nothing to compare to
                return { ...state, lastSyncChange: lastChange };
            }
            return {
                ...invalidateBankBalanceHistory(state),
                lastSyncChange: lastChange,
            };
        }
        default:
            return state;
    }
};
export default balanceHistoryreducer;
